
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'

import DistributionChart from '../components/insights/analytics/distribution-chart.component.vue'
import KpisSuccess from '../components/insights/analytics/kpis-success.component.vue'
import Pivots from '../components/insights/analytics/pivots/pivots.component.vue'
import InsightsNoResults from '../components/insights/insights-no-results.component.vue'
import { UiProgressLinear } from '../components/keen-ui'
import { EpbText } from '../components/shared/epb-text'

import { useKpis } from '../composables/use-kpis'

import { KpiEnum } from '../enums/kpi.enum'

import { AnalyticsMixin } from '../mixins/analytics.mixin'
import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts'

export default defineComponent({
  name: 'Overall',
  components: {
    EpbText,
    InsightsNoResults,
    KpisSuccess,
    DistributionChart,
    Pivots,
    UiProgressLinear,
  },
  mixins: [AnalyticsMixin],
  setup() {
    const { kpiOptions, kpis } = useKpis()

    return { kpiOptions, kpis }
  },
  data() {
    return {
      loading: false,
      messages: this.$epb.messages.insights.analytics,
      totalQueries: undefined,
    }
  },
  computed: {
    hasNoResults(): boolean {
      return !this.loading && !this.totalQueries
    },
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadDistData: ANALYTICS_CONSTS.actions.loadDistData,
      loadSessionsData: ANALYTICS_CONSTS.actions.loadSessionsData,
    }),
    async loadData(): Promise<void> {
      this.loading = true
      try {
        await this.loadDistData()
        if (
          this.kpis.includes(KpiEnum.SESSIONS) ||
          this.kpis.includes(KpiEnum.QUERIES_PER_SESSION)
        ) {
          await this.loadSessionsData()
        }
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error))
      } finally {
        this.loading = false
      }
      await this.$refs.pivotsComponent.loadData()
    },
  },
})
